import * as React from "react";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { FormHelperText, useTheme } from "@mui/material";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
function getStyles(iri, preselectedTag, theme) {
  return {
    fontWeight:
      preselectedTag.indexOf(iri) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}
export default function MultipleSelectChipAuteur({ auteur, handleChange, selectError }) {
  const theme = useTheme();
  const users = useSelector((state) => state.user.allUsers);

  const [authorList, setAuthorList] = React.useState([]);

  const filterAuthor = () => {
    let utilisator = users;
    utilisator = utilisator.filter((u) => u.roles.includes("ROLE_AUTHOR"));
    return utilisator;
  };

  React.useEffect(() => {
    setAuthorList(filterAuthor());
  }, [users]);

  return (
    <FormControl fullWidth error={Boolean(selectError)}>
      <InputLabel id="demo-multiple-chip-label">Auteurs</InputLabel>
      <Select
        name="users"
        variant="outlined"
        multiple
        labelId="demo-multiple-chip-label"
        id="demo-multiple-chip"
        value={auteur}
        onChange={handleChange}
        input={<OutlinedInput id="select-multiple-chip" label="Auteurs" />}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((user) => {
              const label = user.split("/");
              return <Chip key={user} label={label[label.length - 1]} />;
            })}
          </Box>
        )}
        MenuProps={MenuProps}
      >
        {authorList.map((user) => (
          <MenuItem
            key={user.id}
            value={`/api/users/${user.id}/${user.fullname}`}
            style={getStyles(`/api/users/${user.id}/${user.fullname}`, auteur, theme)}
          >
            {user.fullname}
          </MenuItem>
        ))}
      </Select>
      {selectError && <FormHelperText>{selectError}</FormHelperText>}
    </FormControl>
  );
}
MultipleSelectChipAuteur.propTypes = {
  auteur: PropTypes.oneOfType([PropTypes.array]).isRequired,
  handleChange: PropTypes.func.isRequired,
  selectError: PropTypes.string.isRequired,
};
